// extracted by mini-css-extract-plugin
export default {"reason":"readonly-comment-box-module__reason--CzzUh"};